import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
} from '@angular/core';
import { BreakpointObserverService } from '../services/breakpoint-observer.service';

@Directive({
  selector: '[appEqualizeCardsHeight]',
})
export class EqualizeCardsHeightDirective implements AfterViewInit {
  // CSS selectors for blocks to update
  @Input('appEqualizeCardsHeight') selectors!: string[];
  @Input() featuresListMinMaxHeight: string[] = ['70px', '262px'];

  constructor(
    private host: ElementRef<HTMLElement>,
    private breakpointObserver: BreakpointObserverService
  ) {}

  ngAfterViewInit(): void {
    this.equalizeAllGroups();
  }

  // Allow host to call for equalize on featureExtended()
  public equalize(): void {
    this.equalizeAllGroups();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.equalizeAllGroups();
  }

  private equalizeAllGroups(): void {
    if (this.breakpointObserver.isMobile.value) return;
    const container = this.host.nativeElement;

    for (const sel of this.selectors) {
      const els = Array.from(container.querySelectorAll<HTMLElement>(sel));
      if (!els.length) continue;

      if (sel === '.features-list') {
        this.equalizeFeaturesList(els);
        continue;
      }

      // reset
      els.forEach((el) => (el.style.height = 'auto'));

      // measure max
      const maxH = Math.max(
        ...els.map((el) => el.getBoundingClientRect().height)
      );

      // apply
      els.forEach((el) => (el.style.height = `${maxH}px`));
    }
  }

  private equalizeFeaturesList(nodes: HTMLElement[]): void {
    const anyExtended = nodes.some((n) => n.classList.contains('extended'));
    const size = anyExtended
      ? this.featuresListMinMaxHeight[1]
      : this.featuresListMinMaxHeight[0];
    nodes.forEach((n) => (n.style.height = size));
  }
}
